import React from 'react';
import { FormattedMessage } from 'react-intl';

export const getTradeUserRewardsProgramInfo = user => {
    const tradeUserRewardsProgram = user?.tradeFirm?.rewards?.currentProgram;
    const tradeProtectionTierCode = tradeUserRewardsProgram?.programInfo?.code;
    const tradeProtectionDurationCode = tradeUserRewardsProgram?.childPrograms?.[0]?.code;
    const showTradeRewardsCopy = !!tradeProtectionDurationCode;

    return { tradeProtectionTierCode, tradeProtectionDurationCode, showTradeRewardsCopy };
};

export const getTradeBuyerProtectionDuration = code => {
    switch (code) {
        case 'ENHANCED_BUYER_PROTECTION_7_DAY':
            return (
                <FormattedMessage id="tradeBuyerProtectionDuration.7days" defaultMessage="7 days" />
            );
        case 'ENHANCED_BUYER_PROTECTION_30_DAY':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionDuration.30days"
                    defaultMessage="30 days"
                />
            );
        case 'ENHANCED_BUYER_PROTECTION_60_DAY':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionDuration.60days"
                    defaultMessage="60 days"
                />
            );
        case 'ENHANCED_BUYER_PROTECTION_90_DAY':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionDuration.90days"
                    defaultMessage="90 days"
                />
            );
        default:
            return null;
    }
};

export const getTradeBuyerProtectionTier = code => {
    switch (code) {
        case 'MEMBER':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionTier.member"
                    defaultMessage="Rewards member"
                />
            );
        case 'BRONZE':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionTier.bronze"
                    defaultMessage="Bronze Rewards member"
                />
            );
        case 'SILVER':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionTier.silver"
                    defaultMessage="Silver Rewards member"
                />
            );
        case 'GOLD':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionTier.gold"
                    defaultMessage="Gold Rewards member"
                />
            );
        case 'PLATINUM':
            return (
                <FormattedMessage
                    id="tradeBuyerProtectionTier.platinum"
                    defaultMessage="Platinum Rewards member"
                />
            );
        default:
            return null;
    }
};
